import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import PaginationCM from "components/shared/Pagination";
import ContactCM from "components/contactus";
import {
  StyledCardContent,
  StyledCard,
  StyledTypography,
  StyledNewMessage,
  StyledCardActions,
  StyledContainer,
  StyledSpan,
  StyledPaper,
  StyledDivIcon,
  StyledDivtext,
} from "./Ticket.style";
import { getContactUsRequest, getTicketsRequest } from "api/requests";
import useHttp from "hooks/use-http";
import { PAGINATION_LIMIT } from "constants";
import LoadingCM from "components/shared/Loading";
import { BsInstagram, BsTelegram, BsWhatsapp } from "react-icons/bs";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import Button from "@mui/material/Button";
import {Helmet} from "react-helmet";

export default function Messages() {
  const { request, loading } = useHttp();
  const [messages, setMessages] = useState({ data: [], count: 0 });
  const [page, setPage] = useState(1);
  const [contact, setContact] = useState([]);

  const getMessages = useCallback(async () => {
    const res = await request({
      url: getTicketsRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
      },
      isMulty: true,
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items?.title,
      status: items?.status == "open" ? "باز" : "بسته شده",
      updated_at: items.updated_at?.string,
      user_seen: items?.user_seen,
    }));

    let resContact = await request({
      url: getContactUsRequest,
      values: {},
    });
    setContact(resContact);

    setMessages({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getMessages();
  }, []);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>پشتیبانی - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="پشتیبانی" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{
                    display: "flex",
                    marginTop: "3px",
                    marginBottom: "3px",
                  }}
                >
                  <StyledDivIcon>
                    <PhoneIcon />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>شماره تماس</h4>
                    <p>
                      <a href={"tel:" + contact?.a?.phone_number}>
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.phone_number}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a href={"tel:" + contact?.b?.phone_number}>
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.phone_number}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{ display: "flex", marginTop: "2px" }}
                >
                  <StyledDivIcon>
                    <BsInstagram size="26" />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>اینستاگرام</h4>
                    <p>
                      <a
                        href={
                          "https://www.instagram.com/" + contact?.a?.instagram
                        }
                        target="_blank"
                      >
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.instagram}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a
                        href={
                          "https://www.instagram.com/" + contact?.b?.instagram
                        }
                        target="_blank"
                      >
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.instagram}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{
                    display: "flex",
                    marginTop: "2px",
                    marginBottom: "20px",
                  }}
                >
                  <StyledDivIcon>
                    <BsTelegram size="26" />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>تلگرام</h4>
                    <p>
                      <a
                        href={"https://t.me/" + contact?.a?.telegram}
                        target="_blank"
                      >
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.telegram}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a
                        href={"https://t.me/" + contact?.b?.telegram}
                        target="_blank"
                      >
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.telegram}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{
                    display: "flex",
                    marginTop: "2px",
                    marginBottom: "20px",
                  }}
                >
                  <StyledDivIcon>
                    <BsWhatsapp size="26" />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>واتساپ</h4>
                    <p>
                      <a
                        href={"https://wa.me/" + contact?.a?.email}
                        target="_blank"
                      >
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.email}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a
                        href={"https://wa.me/" + contact?.b?.email}
                        target="_blank"
                      >
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.email}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
            </Grid>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  تیکت های من
                </Typography>
              </StyledCardContent>
              <CardContent>
                <div style={{ textAlign: "left" }}>
                  <Link to={`/ticket/new`}>
                    <Button variant="outlined" style={{ marginLeft: "20px" }}>
                      {/* <AddLocationIcon />{" "} */}
                      <span style={{ marginRight: "10px" }}>تیکت جدید</span>
                    </Button>
                  </Link>
                </div>
                {messages.count < 1 ? (
                  <div style={{ textAlign: "center", padding: "28px" }}>
                    تیکت یافت نشد
                  </div>
                ) : (
                  <StyledContainer pb={2} spacing={2} mt={2}>
                    {messages.data.map((items, index) => (
                      <StyledCard key={"card" + index}>
                        {items.user_seen == false ? (
                          <StyledNewMessage>پیام جدید</StyledNewMessage>
                        ) : (
                          ""
                        )}
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 15 }}
                            color="#070937"
                            gutterBottom
                            mb={2}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <StyledSpan>{index + 1}</StyledSpan>
                            <span>{items?.title}</span>
                          </Typography>
                          <StyledTypography variant="body2">
                            <span>وضعیت : </span>
                            {items.status}
                          </StyledTypography>
                          <StyledTypography variant="body2">
                            <span>آخرین بروزرسانی : </span>
                            {items.updated_at}
                          </StyledTypography>
                        </CardContent>
                        <StyledCardActions style={{ direction: "ltr" }}>
                          <Link to={`/ticket/${items.id}`} key={"list" + index}>
                            <Button size="small">
                              <KeyboardArrowLeftIcon /> مشاهده تیکت
                            </Button>
                          </Link>
                          <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                          >
                            {items.date}
                          </Typography>
                        </StyledCardActions>
                      </StyledCard>
                    ))}
                    <Grid container my={2} spacing={1}>
                      <Grid item xs={12}>
                        <PaginationCM
                          handleChange={(e, val) => setPage(val)}
                          page={page}
                          limit={PAGINATION_LIMIT}
                          count={messages.count}
                        />
                      </Grid>
                    </Grid>
                  </StyledContainer>
                )}
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
